import { Cliente } from 'app/modulos/venda/localizador/cliente/cliente';
import { Municipio, Uf } from 'app/modulos/venda/entrega/uniao';
import { PedidoItem } from './pedido-item';

// `trocoPara` e obrigatorio: 0 quando o cliente tem o valor exato.
export type PedidoPagamento = {
  sequencial: number;
  formaIdentificador: number;
  formaNome: string;
  total: number;
  trocoPara: number;
  pago: boolean;
};

// So na leitura. A troca de situacao feita pela retaguarda grava `motivo` (mesmo numero
// da situacao, ex.: Rejeitado 91) e `observacoes`, mas nao grava `situacao`.
export type PedidoOcorrencia = {
  id: string;
  momento: string;
  situacao?: PedidoSituacao;
  motivo: number;
  observacoes?: string;
};

export class Pedido {
  id: string;
  // Vem preenchido na LEITURA (GET integracao/pedido/{id}); no envio nao mandamos.
  codigo: string;
  situacao: PedidoSituacao;
  // Quando o pedido foi feito (ISO). So na leitura.
  momento: string;
  // Nome da unidade que recebeu o pedido. So na leitura.
  lojista: string;
  tipo: PedidoTipo;
  empresa: {
    id: string;
    codigo: string;
    nome: string;
  };
  estabelecimento: {
    id: string;
    codigo: string;
    nome: string;
  };
  localizador: {
    id: string;
    codigo: string;
    nome: string;
    tipo: number;
  };
  // `local` e `responsavel` sao numeros; `municipio` e string, nao a entidade que o
  // estabelecimento devolve; `complemento` recusa string vazia mas aceita ausente.
  // `municipio` e `uf` sao OBJETOS embutidos desde 2026-09-01. Mandar string faz o Mongoose
  // recusar: "Cast to Embedded failed for value ... because of ObjectExpectedError". Sao as
  // mesmas entidades que `aps://uniao/uf` e `aps://uniao/municipio` devolvem.
  pedidoEntrega: {
    cep: string;
    logradouro: string;
    // Inteiro exigido pela aps; "S/N" vai 0.
    numero: number;
    // Enum da aps: Estabelecimento 10, Destinatario 30. Nao e o numero do endereco.
    local: number;
    bairro: string;
    municipio: Municipio;
    uf: Uf;
    responsavel: number;
    complemento?: string;
  };
  pedidoPagamentos: PedidoPagamento[];
  referencia: string;
  modelo: PedidoModelo;
  // Exigido pelo `pedido/grava` desde 2026-09-01: sem ele a resposta e 400 "cliente should
  // not be empty" - mensagem que parece falar do `pedidoCliente`, mas fala deste campo.
  // O backend so verifica que nao esta vazio (`{}` passa, `""` nao); mandamos o mesmo
  // conteudo do `pedidoCliente` porque e o dado verdadeiro. Formato oficial: a confirmar.
  cliente: Cliente;
  pedidoCliente: Cliente;
  pedidoItens: PedidoItem[];
  subtotal: number;
  acrescimo: number;
  frete: number;
  abatimento: number;
  desconto: number;
  total: number;
  pedidoOcorrencias?: PedidoOcorrencia[];
}

export enum PedidoSituacao {
  Pendente = 10,
  Autorizado = 30,
  Expedido = 40,
  Entregue = 50,
  Encerrado = 70,
  Cancelado = 90,
  Rejeitado = 91,
}

export enum PedidoTipo {
  Balcao = 10,
  Autoatendimento = 12,
  Mesa = 110,
  Comanda = 120,
  DriveThru = 130,
  Delivery = 210,
  Encomenda = 220,
}

export enum PedidoModelo {
  Constel = 10,
}
